<div
  *ngIf="employee"
  [ngClass]="{
    card: true,
    'employee-card': true,
    'shape-hover': selectedFormatShape?.asset,
    selected: isSelectedEmployeeCard()
  }"
  #employeeCard>
  <div class="card-horizontal" (click)="selectEmployeeCard()">
    <div class="img-square-wrapper" [ngStyle]="{ borderLeft: getBorderColor(), borderRadius: '5px' }">
      <img class="employee-img" src="{{ getEmployeeThumbnail() }}" alt="User profile" loading="auto" />
    </div>
    <div class="card-body" [ngStyle]="{ 'background-color': employee.shade || 'transparent' }">
      <div class="d-flex justify-content-between">
        <span [class]="'card-title ' + statusLabel">{{ statusLabel | uppercase }}</span>
        <div class="d-flex">
          <div class="d-flex py-1 employee-tags-box">
            <div
              data-toggle="tooltip"
              data-placement="top"
              [title]="ta.tag.label"
              onmouseover="this.style = 'transform: scale(1.5)!important;transition: all 0.5s!important;'"
              onmouseleave="this.style = 'transform: scale(1)!important;transition: all 0.5s!important;'"
              class="employee-card-shape"
              (click)="eraseTag(ta)"
              [id]="ta?.tag?.shape.id"
              *ngFor="let ta of getEmployeeTags()"
              [innerHTML]="sanitizeSVGString(ta?.tag?.shape?.coloredAsset)"></div>
          </div>
          <app-job-count
            data-toggle="tooltip"
            data-placement="top"
            [title]="getCurrentAssignmentNames(employee)"
            class="mx-1 py-1"
            [jobCount]="employee?.jobBoardJobs?.length">
          </app-job-count>
        </div>
      </div>
      <p [class]="'card-text ' + statusClassName" class="">
        {{
          employee?.employeeAlias !== '' && employee?.employeeAlias !== null
            ? employee.employeeAlias
            : employee.firstName + ' ' + employee.lastName
        }}
      </p>
      <div class="d-flex justify-content-between mr-2">
        <p [class]="'card-text ' + statusClassName" class="">{{ employee?.employeeUnionClass?.name }}</p>
        <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="dropdown">
          <img
            click="$event.stopPropagation();selectEmployeeCard(employee);"
            style="width: 20px; min-height: 20px"
            class="dropdown-toggle action-button"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            src="/assets/images/icon/horizontal_dots.svg"
            alt="" />
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item" (click)="employeeAction('viewProfile')" style="color: #8fc4ff">
              <i class="fa fa-info-circle"></i>View Profile
            </button>
            <button
              [disabled]="jobBoardLocked"
              class="dropdown-item"
              (click)="selectEmployeeCard(employee); employeeAction('move'); $event.stopPropagation()">
              <i class="fa fa-arrow-alt-right"></i>Move to Job...
            </button>
            <button
              [disabled]="jobBoardLocked"
              class="dropdown-item"
              (click)="selectEmployeeCard(employee); employeeAction('copy'); $event.stopPropagation()">
              <i class="fa fa-copy"></i>Copy to Job...
            </button>
            <button
              [disabled]="jobBoardLocked"
              class="dropdown-item"
              (click)="selectEmployeeCard(employee); employeeAction('remove'); $event.stopPropagation()"
              style="color: red">
              <i class="fa fa-trash"></i>Remove
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
